<template>
    
    <div>

        <div v-if="error" class='alert alert-danger'>
            {{error}}
        </div>

        <div v-if="buyerId == false && error == false">
            <loading-full :status='statusmensagem' />
        </div>
        
        <div v-if="buyerId != false">

        <div class='row mt-2'>
            <div class='col-12'>
                <!-- <a class='f6 gray pointer' @click='showCardsBands = !showCardsBands' > ver cartões aceitos </a> -->
                    <div v-if='showCardsBands'>
                        <span  v-for="creditCart in acceptCreditCards">
                            <img :src='"https://stc.pagseguro.uol.com.br"+creditCart.images.SMALL.path'>
                        </span>
                    </div>
            </div>
        </div>

        <vue-form v-if="isCredit" name="payment" v-model="paymentInfo" validate="validatePagInfo" class='mt-2'>
            
            <div class='row'>
            
                <div class='col-12 col-lg-7 relative'>
                    <vue-field @change="getCardBrand" type="string" name="cardnumber"  label="Número do Cartão" validations="creditCard" required></vue-field> 
                    <img class="currentcardband" v-if="cardBrand.name && acceptCreditCards[cardBrand.name.toUpperCase()]" :src='"https://stc.pagseguro.uol.com.br"+acceptCreditCards[cardBrand.name.toUpperCase()].images.SMALL.path'>
                </div>

                <vue-field class='col-12 col-lg-3' type="string" name="cvv" label="CVV" required ></vue-field>
                <vue-field class='col-12 col-lg-5' type="card-valid-date" :showDay="false" name="duedate" label="Data de Validade"  required ></vue-field>
                <vue-field class='col-12 col-lg-5' type="select" :options="installmentOptions" name="installments" label="Parcelamento"  required ></vue-field>
            
            </div>
            
        </vue-form>
        
        <div class='mt-4'>
                <a @click='customAddressBilling = ! customAddressBilling' class='pointer'> Informar outro Pagador  </a>
                <div class='row mt-3' v-if="customAddressBilling" key="addressbilling">
                    <div class="col-12">
                        <b>Informações do proprietário</b>
                        <hr/>
                            <vue-form  name="payment" v-model="buyerInfo" >
                                    <vue-field  class='col-12 col-lg-6' type="string" name="name" label="Nome Completo" required></vue-field>
                                    <vue-field  class='col-12 col-lg-6' type="string" name="cpf" label="CPF" required></vue-field>
                                    <vue-field  class='col-12 col-lg-6' type="string" name="email" label="Email" required :validations="['email']"></vue-field>
                                    <vue-field  class='col-12 col-lg-6' type="age" name="birthday" label="Data de Nascimento" required ></vue-field>
                                    <vue-field  class='col-12 col-lg-6' type="string" name="telephone" label="Telefone" required ></vue-field>
                                    <vue-field  class='col-12 col-lg-6' type="address" name="address" label="Endereço de cobrança" />
                            </vue-form>
                    </div>
                </div>
 
        </div>

        <!-- <pre>{{ this.$props }}</pre> -->

        </div>

    </div>   
</template>

<script>

import api from '@/api';
import moment from 'moment';
// var buscaCep = require('busca-cep');
//LETODO - includ installs and check foraccept payment types and compare with paymentOptions

var _SANDBOX = (_ENV == 'development')

import validadeFormMixins from "@/mixins/validateForms"
export default {
    mixins:[validadeFormMixins],

    props:['paymentOption','amount','value'],

    data(){
        return { 
            showCardsBands:false,
            currentCreditCardBand:false,
            sessionId:'',
            customAddressBilling:false,
            paymentInfo:{
                cardnumber:'',
                cvv:'',
                duedate:'',
                installments:1,
                billingAddressPostalCode:'',
                billingAddressStreet:'',
                billingAddressDistrict:'',
                billingAddressCity:'',
                billingAddressState:'',
                billingAddressNumber:'',
                creditCardHolderName:'',
                creditCardHolderBirthDate:'',
                creditCardHolderCPF:'',
                creditCardHolderPhone:'',
            },

            creditCardInstallmentsOptions:[], //0: [{installmentAmount: 48.45 interestFree: true, quantity: 1, totalAmount: 48.45},...]
            token:'',
            buyerId:false,
            currentCardType:'',
            scriptLoaded:false,
            error:false,
            acceptCreditCards:[],
            cardBrand:false,
            statusmensagem:'',
        }
    },


    created(){

        if(!window.PagSeguroDirectPayment){
            this.loadPaymentScript()
        }else{
            this.scriptLoaded = true;
        }
   },

    watch:{
        scriptLoaded:function(){
            this.startSession();
        },

        sessionId:function(val){
            PagSeguroDirectPayment.setSessionId(this.sessionId);
            this.checkAvaliablePaymentOptions();
            this.setBuyerId();
        },
        
        buyerId:function(val){
            var info = {
                        senderHash:this.buyerId,
                        }
            this.$emit('input', info )
            this.$emit('change', info ) 
        },

        // cardBrand:function(val){
        //     this.paymentInfo.brand = val
        // },

        token:function(val){

            let installments = this.creditCardInstallmentsOptions[ this.paymentInfo.installments - 1 ];
            var info = {...this.paymentInfo,
                        maxInstallmentNoInterest: this.paymentOption.maxInstallments,
                        installmentQuantity: installments.quantity,
                        installmentValue: installments.installmentAmount,
                        creditCardToken:val,
                        senderHash:this.buyerId,
                        }
            this.$emit('input', info )
            this.$emit('change', info )
        },

        paymentInfo:function(val, oldval){
            if(val.cardnumber != oldval.cardnumber){
                this.getCardBrand(val.cardnumber);
            }
            
            if(val.installments != oldval.installments){
                //LETODO - include totalTax getting from installments
                // let installments = this.creditCardInstallmentsOptions[ this.paymentInfo.installments - 1 ];
            }

        },

        cardBrand:function(){
            this.getInstallments()
        },


    },

    computed:{
        // total:function(){
        //     return this.$store.getters['OrderStore'].getTotalFinal
        // },
        paymentType:function(){
            return this.paymentOption.paymentType
        },
        isBoleto:function(){
            return this.paymentOption.paymentType == "boleto"
        },
        isCredit:function(){
            return this.paymentOption.paymentType == "credit"
        },
        paymmentProviderId:function(){
            return this.paymentOption.paymentProviderId
        },
        paymmentProviderName:function(){
            return this.paymentOption.providerId
        },
        paymentProviderUrl:function(){
            return `PaymentProviders/${this.paymmentProviderId}/${this.paymmentProviderName}`
        } ,
        
        creditCardBandImage:function(){
            //   return "https://stc.pagseguro.uol.com.br"+creditCart[this.].images.SMALL.path
        },
        dueDateMonth:function(){
            if( this.paymentInfo.duedate != ''){
                return this.paymentInfo.duedate.match(/^(\d\d\d\d)-(\d\d)/)[2]
            }else{
                return ''
            }
        },
        dueDateYear:function(){
              if( this.paymentInfo.duedate != ''){
                    return this.paymentInfo.duedate.match(/^(\d\d\d\d)-(\d\d)/)[1]
              }else{
                return ''
            }
        },
        installmentOptions:function(){
                // {'name':'Masculino',value:'M'}
            let options = []
            _.each( this.creditCardInstallmentsOptions, v=>{ 
                    
                    let percentual = v.totalAmount/this.amount/v.quantity;
                    let name = `${v.quantity} X R$ ${v.installmentAmount} = ${v.totalAmount}`;
                    if( v.quantity <= this.paymentOption.maxInstallments )
                         options.push({ name, value:v.quantity })
            } )
            return options;
        },
        
        buyerInfo:{
            set:function(val){
                this.$store.commit('OrderStore/updateBuyer', val)
            },
            get:function(val){
                return this.$store.getters['OrderStore/buyer']
            }
        },

    },



    methods:{

        loadPaymentScript:function(){
            this.error = false;
            this.scriptLoaded = false;
            let pagseguroScript = document.createElement('script')
            pagseguroScript.async = true;
            pagseguroScript.onload = () => {
                this.statusmensagem = ''
                this.scriptLoaded = true;
            }
            pagseguroScript.onerror = () => {
                console.error("Error ao carregar script")
                this.error = "Erro carregando biblioteca de pagamento! Tentando automaticamente em 5 segundos, ou entre em contato com o administrador!";
                setTimeout(this.loadPaymentScript,2000)
           }
            this.statusmensagem = 'carregando informações da meio de pagamento...'
            if( _SANDBOX ){
                pagseguroScript.setAttribute('src', 'https://stc.sandbox.pagseguro.uol.com.br/pagseguro/api/v2/checkout/pagseguro.directpayment.js')
            }else{
                pagseguroScript.setAttribute('src', 'https://stc.pagseguro.uol.com.br/pagseguro/api/v2/checkout/pagseguro.directpayment.js')
            }
            document.head.appendChild(pagseguroScript)
        },

        startSession:async function(){
            this.sessionId = false;
            this.error = false;
            this.statusmensagem = 'gerando session do comprados...'
            let res = await api.getJSONAsync(`${this.paymentProviderUrl}/getSession?sandbox=${_SANDBOX}`)
            if(res.error){
                if(res.status = 401){
                    this.error = 'Erro "PaypalSessionDenied" - Contacte o Admministrador ';
                }else{
                    this.error = this.message;
                }
                setTimeout(this.startSession,2000)
                return;
            }
            if(_.has(res,'session.id')){
                  this.statusmensagem = ''
                this.sessionId = _.get(res,'session.id')
            }
        },

        validatePagInfo:async function(){

        },

        setBuyerId:function(){
            this.error = false;
            this.statusmensagem = 'gerando identificação unica do comprador'

            PagSeguroDirectPayment.onSenderHashReady((response)=>{
                
                if( _.get(response,'status') == 'error') {
                    console.log(response.message);
                    this.error = response.message;
                    this.statusmensagem = ""
                    setTimeout(this.setBuyerId,1000)
                    return false;
                }
                 var hash = _.get(response,'senderHash')
                 if(!hash){
                      this.error = "Erro carregando formulário de pagamento do pagseguro. Tente novamente!"
                      setTimeout(this.setBuyerId,1000)
                 }
                this.buyerId= response.senderHash; //Hash estará disponível nesta variável.
            });
        },

        checkAvaliablePaymentOptions:function(){
        
            PagSeguroDirectPayment.getPaymentMethods({
                amount: parseInt(this.amount,10),
                success: (response) => {
                    //meios de pagamento disponíveis
                   var credit =  _.get(response, 'paymentMethods.CREDIT_CARD',false)
                   this.acceptCreditCards = _.get(credit,'options');

                   //ch eck i paymentoptions is accept by pagseguro
                },
                error: function(response) {
                     this.error = response.message;
                    //tratamento do erro
                },
                complete: function(response) {
                    //tratamento comum para todas chamadas
                }
            });
        },

      

        getCardBrand:function(){
            return new Promise( (resolve, reject)=>{
                PagSeguroDirectPayment.getBrand({
                    cardBin: parseInt(this.paymentInfo.cardnumber,10),
                        success: (response)=> {
                            
                            //bandeira encontrada
                            this.cardBrand = response.brand;
                              resolve(true)
                        },
                        error: (response)=> {
                            //tratamento do erro
                                    reject(response)
                        },
                        complete: (response)=> {
                            //tratamento comum para todas chamadas
                        }
                });
            })
        },

        getInstallments:function(){
            
           PagSeguroDirectPayment.getInstallments({	
                    amount: this.amount,
                    brand: this.cardBrand.name,
                    maxInstallmentNoInterest: this.paymentOption.maxInstallments,
                    success: (response) => {
                        //opções de parcelamento disponível
                        
                        console.log(response);
                        this.creditCardInstallmentsOptions = response.installments[this.cardBrand.name]
                    },
                    error: (response) => {
                        //tratamento do erro
                        this.creditCardInstallmentsOptions = []
                    },
                    complete: function(response) {
                        //tratamento comum para todas chamadas
                    }
            });
        },


        getCardToken:function(){    
               return new Promise( (resolve, reject)=>{
                   var param = {
                    cardNumber: this.paymentInfo.cardnumber,
                    brand: this.cardBrand.name,
                    cvv: this.paymentInfo.cvv,
                    expirationMonth: this.dueDateMonth,
                    expirationYear: this.dueDateYear,
                    success: (response) => {
                        //token gerado, esse deve ser usado na chamada da API do Checkout Transparente
                        this.token = response.card.token
                        resolve(true)
                    },
                    error: (response) => {
                        //tratamento do erro
                        this.token = '';
                        console.error(response)
                        reject(response)
                    },
                    complete: (response) => {
                        //tratamento comum para todas chamadas
                    }
                    }
                    PagSeguroDirectPayment.createCardToken(param);
                })
        },

        



        searchCep:async function(val){
                console.log('mudou cep')
            
                var cep = val.replace(/\D/g, '');
                //Verifica se campo cep possui valor informado.
                if (cep != "") {
                    //Expressão regular para validar o CEP.
                    var validacep = /^[0-9]{8}$/;
                    //Valida o formato do CEP.
                    if(validacep.test(cep)) {
                
                        var url = `https://viacep.com.br/ws/${cep}/json`;
                        
                        var res = await api.getJSONAsync(url,{},true);
                        // .then(res => {
                                    //"cep": "70855-020", //   "logradouro": "SQN 407 Bloco B", //   "complemento": "", //   "bairro": "Asa Norte", //   "localidade": "Brasília", //   "uf": "DF", //   "unidade": "", //   "ibge": "5300108", //   "gia": "" // }
                        if(res.cep){
                            this.paymentInfo.billingAddressPostalCode = res.cep;
                            this.paymentInfo.billingAddressStreet = res.logradouro;
                            this.paymentInfo.billingAddressDistrict = res.bairro;
                            this.paymentInfo.billingAddressCity = res.localidade;
                            this.paymentInfo.billingAddressState = res.uf;
                        }
                        // })

                    }
                
                }
               
        },


        validate:async function(){

            this.error = false;
            
            var formValid = await this.validateForms();
            if(formValid){
                //se credito, vejo se consigo pegar o token
                if(this.isCredit){
                    try{
                        if( this.cardBrand == false){
                            await this.getCardBrand();
                        }
                        let res = await this.getCardToken();
                        return res;
                    }catch(e){
                        this.error = e.errors;
                        return false;
                    }
                }
                //se credito, vejo se consigo pegar o token
                if(this.isBoleto){
                    return true;
                }


            }else{
                return false;
            }
        
        }





    }

}
</script>

<style scoped lang="stylus">
    .currentcardband{
        position:absolute;
        right:17px;
        margin-top:-44px;
    }

</style>
